 .errorText {
    font-size: 14px;
    font-weight: 500;
    color: #d9384b;
    padding-left: 2px;
    padding-top: 6px;
  }